import { Link } from "@tanstack/react-router";

/**
 * Masthead: stort centreret "Flâneriet" i Spectral,
 * kursiv tagline. 2px toplinje over.
 */
export function Masthead() {
  return (
    <div className="content-canvas">
      <div className="rule-strong text-center pt-8 pb-4 md:pt-[34px] md:pb-[14px]">
        <Link
          to="/"
          className="inline-block"
          aria-label="Flâneriet – til forsiden"
          title="Flâneur (fr.) – en, der spadserer uden mål; iagttageren, der lader sig drive af nysgerrighed frem for hastværk."
        >
          <span
            className="font-serif font-normal text-ink block leading-none tracking-[-0.01em]"
            style={{ fontSize: "clamp(44px, 12vw, 98px)" }}
          >
            Flâneriet
          </span>
        </Link>
        <p className="mt-3 md:mt-[14px] font-serif italic font-light text-[15px] md:text-[21px] text-ink-soft">
          at drive uden mål gennem byen, bogen, glasset
        </p>
      </div>
    </div>
  );
}
